import * as yup from 'yup';
import { isDate, startOfDay } from 'date-fns';
import { getPlainDateString } from '../../../services/queries/MaggieMetricsQueries';

export const transactionDateSchema = (): yup.StringSchema =>
  yup.string().nullable().required('Transaction Date is a required field').transform(transformDateToString);

export const futureDateSchema = () =>
  yup.date().optional().nullable().min(startOfDay(new Date()), 'Date cannot be in the past');

//cf https://github.com/react-hook-form/react-hook-form/issues/7730#issuecomment-1028794992
export function transformDateToString(value?: Date | string | null, originalValue?: string | Date | null) {
  if (isDate(originalValue)) {
    return getPlainDateString(originalValue as Date);
  } else {
    return originalValue ?? null;
  }
}

export const proceedsTypeSchema = () =>
  yup
    .array()
    .nullable()
    .min(1, 'At least 1 Proceed Type Required')
    .required('Proceeds Type is a required field');
